import type { InvoiceFormFields } from '@/modules/cart/domain/Cart';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { INVOICE_URL } = environment;

export async function postAddInvoice(
  payload: InvoiceFormFields
): Promise<{ data: HttpCartDto }> {
  const response = await httpClient.post(INVOICE_URL, payload);
  return Promise.resolve(response);
}
